import { FC } from 'react';

import { Checkbox } from '@hh.ru/magritte-ui';

import FilterItem from 'src/components/Search/Common/Filters/FilterItem';
import { ClusterGroup } from 'src/types/search/common/clusters';

interface FilterItemWithCheckboxProps {
    item: ClusterGroup;
    name: string;
    checked: boolean;
    onChange: (id: string) => void;
}

const FilterItemWithCheckbox: FC<FilterItemWithCheckboxProps> = ({
    item: { title, count, id, disabled },
    name,
    checked,
    onChange,
}) => {
    return (
        <FilterItem
            left={
                <Checkbox
                    name={name}
                    value={id}
                    onChange={() => onChange(id)}
                    checked={checked}
                    dataQaCheckbox={`serp__novafilter-${name}-${id}`}
                />
            }
            title={title}
            count={count}
            disabled={disabled}
        />
    );
};

export default FilterItemWithCheckbox;
